import React from 'react';
import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import { FirewallService as firewallService } from './../../../services/firewall.service';
import { NetworkService } from './../../../services/network.service';
import { ServerService as instanceService } from './../../../services/server.service';
import NetworkRules from './networkRules';
import { getDistUserName } from '../../../utility/utility';
import ReactTooltip from 'react-tooltip';
import { AuditLog } from './../../../services/auditlog.service';
import { timeThursdays } from 'd3-time';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../../constants/server.constant';
import Axios from 'axios';
const isValidDomain = require('is-valid-domain');

class Networking extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sshRootAccess: "",
            ipv4: "",
            ipv6: "",
            addresses: this.props.instance.addresses,
            flavour: this.props.instance.flavor,
            ipv4list: [],
            ipv6list: [],
            firewalls: [],
            filteredFirewalls: [],
            userFirewalls: [],
            securityGroupsData: [],
            ipv4Rules: [],
            ipv6Rules: [],
            securityGroups: this.props.instance.security_groups,
            isdatapresent: false,
            enableAddIpv4: false,
            isPrivateIpExists: false,
            isDone: false,
            getfocus: false,
            inputFirewallSearch: "",
            firewallDropDown: [],
            userinstance: "<user>",
            issshaccess: true,
            iscopyipv4: true,
            iscopyipv6: true,
            isCopyIPAdd: true,
            enableAddPublicIpv4: false,
            additionalIPs: [],
            additionalIPCount: 0,
            currentIp: "",
            enableDeleteIpv4PopUp: false,
            setIpPrice: 0,
            setIpLimit: 0,
            rDnsIpv4List: [],
            rDnsIpv6List: [],
            rDnsIpv4SliderCurrIdx: -1,
            rDnsIpv6SliderCurrIdx: -1,
            rDnsIpv4CurrVal: '',
            rDnsIpv6CurrVal: '',
            currSliderIp: 0,
            rdnsErrMsg: "",
            rdnsSubmitLoader: false,
            indexIp: 0,
            userId: localStorage.getItem("userId")
        };

        this.addSelectedFirewall = this.addSelectedFirewall.bind(this);
        this.removeSelectedFirewall = this.removeSelectedFirewall.bind(this);
        this.handleinputs = this.handleinputs.bind(this);
        this.allocateIpv4 = this.allocateIpv4.bind(this);
        this.getFocus = this.getFocus.bind(this);
        this.firewallSearch = this.firewallSearch.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.getFlavorDetails = this.getFlavorDetails.bind(this);
        this.checkAdditionalIp = this.checkAdditionalIp.bind(this);
        this.getAdditionalIpDetails = this.getAdditionalIpDetails.bind(this);
        this.deleteIpAdd = this.deleteIpAdd.bind(this);
        this.addPublicIpv4 = this.addPublicIpv4.bind(this);
        this.addRDNSDetails = this.addRDNSDetails.bind(this);
        this.rDNSSlider = this.rDNSSlider.bind(this);
        this.OnSubmitRdnsRequest = this.OnSubmitRdnsRequest.bind(this);
        this.rdnsSliderOnCancel = this.rdnsSliderOnCancel.bind(this);
        //this.rdnsSliderOnClose = this.rdnsSliderOnClose.bind(this) ;
    }
    escfunction = (event) => {
        if(event.keyCode === 27) {
            $('.addedFirewall_dropdown').removeClass('active');
            $(".added_firewall.clearfix").removeClass("active");
            $("body").removeClass("popup_no_scroll");
            this.setState({
                enableAddPublicIpv4: false,
                enableDeleteIpv4PopUp: false,
                enableAddIpv4: false
            });
        }
    };
    getFocus = () => {
        $(".added_firewall.clearfix").toggleClass("active");
    };
    componentDidMount() {
        $("html").animate({ scrollTop: 0 }, "slow");
        this.props.bgShadowHandler(true);
        document.addEventListener("keyup", this.escfunction, false);
        $("main").removeClass("ls_expand");

        $('.network_setting_module .ip_head_wrap .common_cta_btn .ip_btn_private').click(function (e) {

            $('.add_private_ipv4').addClass('active');
        });


        $('.network_setting_module .ip_head_wrap .common_cta_btn .ip_btn_public').click(function (e) {

            $('.add_public_ipv4').addClass('active');
        });
        this.getIpLimitAndPrice();

    }

    getFlavorDetails(flavorId) {

        let flavorList = JSON.parse(localStorage.getItem('BMflavors'));

        if(flavorList !== null && flavorList !== undefined) {
            let flavorObj = undefined;
            try {
                flavorObj = flavorList.find(item => item.id === flavorId);
            }
            catch(err) {
                return false;
            }

            if(flavorObj === undefined) {
                return false;
            }

            if(flavorObj.type == "BM") {

                return true;
            }
            return false;
        }

        return false;
    }
    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
        this.props.msgHandler("");
    }
    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };
    getImageDetails = () => {

        instanceService.getImageDetailsByRegion(this.props.imageRegionUrl).then((resp) => {
            if(resp === false) {
                this.props.bgShadowHandler(false);
            }
            let distributionList = resp.distributionImages;

            for(let i = 0; i < distributionList.length; i++) {
                if(this.props.instance.image.id === distributionList[i].id) {

                    this.setState
                        ({
                            userinstance: getDistUserName(distributionList[i].distribution.toLowerCase())
                        });
                }
            }
            // this.getServerDetails();
        });
    };

    getAdditionalIpDetails = (param) => {
        NetworkService.getIPDetails(this.props.instance.id).then(resp => {
            if(resp === false) {
                this.props.bgShadowHandler(false);
            }
            if(resp.data == "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: [],
                    additionalIPCount: 0
                });
            }
            if(resp.data != "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: resp.data,
                    additionalIPCount: resp.data.length
                });

            }
            this.getNetworkDetails();

        })
            .catch(error => {
                this.props.bgShadowHandler(false);
            });
    };

    checkAdditionalIp = (ip) => {
        let id = this.state.additionalIPs.find(elem => elem.ip_address == ip);

        if(id == undefined) {
            return false;
        }
        return true;

    };
    getMainIp = () => {

        let open = this.state.ipv4list;
        let compute = this.state.additionalIPs;

        let result = open.filter(open => !compute.some(compute => open.ipv4addrs == compute.ip_address));
        this.setState({
            resultIP: result[0].ipv4addrs
        });

    };
    getFirewallDrop = (event) => {
        this.setState({
            firewallDropDown: this.state.filteredFirewalls, isDropDownActive: true
        });
        $('.addedFirewall_dropdown').addClass('active');

    };


    firewallSearch = (event) => {
        let items = [...this.state.filteredFirewalls];
        let name = event.target.name;
        let val = event.target.value;
        let filtDropDownComp = {};
        if(val.length > 0) {
            filtDropDownComp = items.filter(inst => inst.name.toLowerCase().includes(val.toLowerCase()));
        }
        else {
            filtDropDownComp = items;
        }

        this.setState({ [name]: val, firewallDropDown: filtDropDownComp.slice(0, 5), isDropDownActive: true });
        $('.addedFirewall_dropdown').addClass('active');
    };

    getInstanceData = () => {
        instanceService.getServerDetailsById(this.props.computeRegionUrl, this.props.instance.id).then(resp => {
            if(resp === false) {
                this.props.bgShadowHandler(false);
            }
            let securirty_arr = resp.security_groups;
            let security_array_new = [];
            if(securirty_arr != undefined)
                security_array_new = securirty_arr.reduceRight(function (r, a) { r.some(function (b) { return a.name === b.name; }) || r.push(a); return r; }, []);

            this.setState({
                securityGroups: security_array_new,
                ipv4Rules: [],
                ipv6Rules: [],
                addresses: resp.addresses
            }, () => this.getAdditionalIpDetails());
            this.getImageDetails();
        });
    };

    getNetworkDetails = () => {
        const address_network = this.state.addresses;

        let ipv4_json = [];
        let ipv6_json = [];
        let publickey = "";
        let privatekey = "";
        NetworkService.getGateWay(this.props.instance.id, this.props.instance.region).then(resp => {
            if(resp === false) {
                this.props.bgShadowHandler(false);
            }
            let gatewayArr = resp.data;
            this.setState({
                gateways: resp.data
            });
            let keys = Object.keys(address_network);
            publickey = keys[0];
            privatekey = keys[1];

            if(address_network.hasOwnProperty(publickey)) {
                for(let i = 0; i < address_network[publickey].length; i++) {
                    if(address_network[publickey][i].version === 4) {
                        let ipv4json = {
                            "ipv4addrs": address_network[publickey][i].addr,
                            "gateway": this.getGateWays(gatewayArr, 4),
                            "type": "Public",
                            "order": this.checkForMain(address_network[publickey][i].addr)

                        };


                        ipv4_json.push(ipv4json);
                        this.setState({
                            sshRootAccess: "ssh " + this.state.userinstance + "@" + ipv4_json[0].ipv4addrs,
                            ipv4: ipv4_json[0].ipv4addrs
                        });

                    }


                }
                for(let i = 0; i < address_network[publickey].length; i++) {
                    if(address_network[publickey][i].version === 6) {

                        let ipv6json = {
                            "ipv6addrs": address_network[publickey][i].addr,
                            "gateway": this.getGateWays(gatewayArr, 6),
                            "type": "Public",
                            "order": 0
                        };
                        ipv6_json.push(ipv6json);
                        if(ipv6_json.length > 0) {
                            this.setState({
                                ipv6: ipv6_json[0].ipv6addrs
                            });
                        }
                    }
                }

            }

            const userName = localStorage.getItem("email");

            if(address_network.hasOwnProperty(privatekey)) {

                this.setState({ isPrivateIpExists: true });

                for(let i = 0; i < address_network[privatekey].length; i++) {
                    if(address_network[privatekey][i].version === 4) {

                        let ipv4json = {
                            "ipv4addrs": address_network[privatekey][i].addr,
                            "gateway": "N/A",
                            "type": "Private",
                            "order": 2
                        };
                        ipv4_json.push(ipv4json);


                    }

                }
                for(let i = 0; i < address_network[privatekey].length; i++) {
                    if(address_network[privatekey][i].version === 6) {

                        let ipv6json = {
                            "ipv6addrs": address_network[privatekey][i].addr,
                            "gateway": "N/A",
                            "type": "Private",
                            "order": 2
                        };
                        ipv6_json.push(ipv6json);
                    }
                }


            }
            ipv4_json.sort(function (a, b) {
                if(a.order < b.order) { return -1; }
                if(a.order > b.order) { return 1; }
                return 0;
            });
            this.setState({
                ipv4list: ipv4_json,
                ipv6list: ipv6_json
            });
            this.getallFirewallDetails();
            this.getInstanceRdnsData();
        });


    };


    checkForMain = (ip) => {
        let compute = this.state.additionalIPs;
        if(compute.length > 0) {
            let result = [];
            for(let i = 0; i < compute.length; i++) {
                if(compute[i].ip_address == ip) {
                    let index = this.state.indexIp;
                    index++;
                    this.setState({
                        indexIp: index
                    });
                    return index;
                }


            }

        }
        return 0;

    };

    getGateWays = (gatewayArr, version) => {

        for(let j = 0; j < gatewayArr.length; j++) {

            if(gatewayArr[j].ip_version == version) {
                return gatewayArr[j].gatewayIpAddrs;
            }
        }
    };

    getallFirewallDetails = () => {
        firewallService.getAllFirewallDetails().then((resp) => {
            if(resp === undefined || resp === false) {
                this.props.msgHandler("Error while fetching firewalls. Please refresh the page.", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;
            }

            if(resp !== undefined && resp.length > 0) {
                let firewallData = [];
                let firewallnames = [];
                for(let i = 0; i < resp.length; i++) {
                    var name = {
                        "name": resp[i].name
                    };
                    if(resp[i].region_name === this.props.instance.region) {
                        firewallnames.push(name);
                    }

                    for(let j = 0; j < this.state.securityGroups.length; j++) {

                        if(resp[i].name === this.state.securityGroups[j].name && resp[i].region_name === this.props.instance.region) {

                            let obj = {
                                "securityid": resp[i].id,
                                "regionurl": resp[i].region_url,
                                "regionname": resp[i].region_name
                            };
                            firewallData.push(obj);

                        }
                    }

                }

                this.setState({
                    securityGroupsData: firewallData,
                    userFirewalls: firewallnames,
                    isDone: true
                });


                let firewall = [];
                for(let j = 0; j < this.state.securityGroups.length; j++) {

                    if(this.state.securityGroups[j].name !== "default") {
                        let securityName = {
                            "name": this.state.securityGroups[j].name
                        };
                        firewall.push(securityName);
                    }

                }
                this.setState({
                    firewalls: firewall
                });
                let finalarr = [];
                for(let i = 0; i < this.state.userFirewalls.length; i++) {
                    let found = false;

                    for(let j = 0; j < this.state.securityGroups.length && !found; j++) {
                        found = this.state.userFirewalls[i].name === this.state.securityGroups[j].name;
                    }

                    if(!found) finalarr.push(this.state.userFirewalls[i]);
                }
                this.setState({
                    filteredFirewalls: finalarr,
                    firewallDropDown: finalarr
                });
                this.getIpv4Ipv6rules();


            }
            else {
                this.props.bgShadowHandler(false);
            }

        });
    };
    getIpv4Ipv6rules = () => {
        if(this.state.securityGroupsData.length > 0) {

            for(let i = 0; i < this.state.securityGroupsData.length; i++) {
                let securityin = [];
                let securityout = [];
                firewallService.getFirewallDetailsByid(this.state.securityGroupsData[i].securityid, this.state.securityGroupsData[i].regionurl)
                    .then((resp) => {
                        this.props.bgShadowHandler(false);
                        if(resp === false) {
                            this.setState({ errorMsg: 'Error While fetching Inbound and Outbound Rules, Try again!', msgType: 'error' });
                            return;
                        }
                        let firewallData = resp.security_group;
                        securityin.push(firewallData.security_group_rules.filter(elem => elem.direction === 'ingress'));
                        securityout.push(firewallData.security_group_rules.filter(elem => elem.direction === 'egress'));
                        let joinin = this.state.ipv4Rules.concat(firewallData.security_group_rules.filter(elem => elem.ethertype === 'IPv4'));
                        let joinout = this.state.ipv6Rules.concat(firewallData.security_group_rules.filter(elem => elem.ethertype === 'IPv6'));
                        this.setState({
                            ipv4Rules: joinin,
                            ipv6Rules: joinout
                        });
                        this.props.bgShadowHandler(false);

                    });

            }
        }
        else {
            this.props.bgShadowHandler(false);
        }

        if(this.state.publicIpStatus == "add") {
            this.props.msgHandler("Public IPv4 added sucessfully");
            this.clearToastMessage();
            this.setState({
                publicIpStatus: ""
            });
        }
        if(this.state.publicIpStatus == "delete") {
            this.props.msgHandler("Public IPv4 deleted sucessfully");
            this.clearToastMessage();
            this.setState({
                publicIpStatus: ""
            });
        }
        this.getMainIp();

    };

    handleinputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            [name]: val
        });
    };
    copyToclipboard = (event, text, type) => {
        if(type === "sshaccess") {
            this.setState({
                issshaccess: false
            });
        }
        else if(type === "ipv4") {
            this.setState({
                iscopyipv4: false
            });
        }
        else if(type === "ipv6") {
            this.setState({
                iscopyipv6: false
            });
        }
        else if(type == "ipv4add") {
            this.setState({
                isCopyIPAdd: false
            });
        }

        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;
    };

    addSelectedFirewall = (params) => {
        this.props.bgShadowHandler(true);
        const requestBody = {
            addSecurityGroup: {
                name: params[0]
            }
        };
        let logInstanceName = this.props.instance.name;
        let logRegion = this.props.instance.region;
        let logFirewallName = params[0];
        instanceService.serverAction(this.props.instance.id, this.props.computeRegionUrl, requestBody)
            .then((resp) => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler("Failed to add firewall \"" + params[0] + "\"", "error");
                    this.clearToastMessage();
                    return;
                }
                const firewallAdded = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall " + logFirewallName + " has been added to instance " + logInstanceName,
                    "operation": "Firewall added to instance",
                    "region": logRegion
                };
                AuditLog.storeAuditLogs(firewallAdded, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({
                    inputFirewallSearch: '',
                    isDropDownActive: false
                });
                $('.addedFirewall_dropdown').removeClass('active');
                this.getInstanceData();
                //this.getallFirewallDetails()

            });


    };
    removeSelectedFirewall = (params) => {
        this.props.bgShadowHandler(true);
        const requestBody = {
            removeSecurityGroup: {
                name: params[0]
            }
        };
        let logInstanceName = this.props.instance.name;
        let logRegion = this.props.instance.region;
        let logFirewallName = params[0];
        instanceService.serverAction(this.props.instance.id, this.props.computeRegionUrl, requestBody)
            .then((resp) => {
                if(resp === false) {
                    this.props.bgShadowHandler(false);
                    this.props.msgHandler("Failed to remove firewall \"" + params[0] + "\"", "error");
                    this.clearToastMessage();
                    return;
                }
                const firewallRemoved = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall " + logFirewallName + " has been removed from instance " + logInstanceName,
                    "operation": "Firewall removed from instance",
                    "region": logRegion
                };
                AuditLog.storeAuditLogs(firewallRemoved, "instance").then((resp) => {
                    if(resp === false);
                });
                this.setState({
                    inputFirewallSearch: '',
                    isDropDownActive: false
                });
                $('.addedFirewall_dropdown').removeClass('active');
                this.getInstanceData();
                //this.getallFirewallDetails()  
            });

    };

    allocateIpv4 = () => {
        this.props.bgShadowHandler(true);
        let logInstanceName = this.props.instance.name;
        let logRegion = this.props.instance.region;
        let rebootStatus = "DO_REBOOT";
        NetworkService.allocatePrivateIpv4(this.props.instance.id, this.props.computeRegionUrl, this.props.instance.region, rebootStatus).then((resp) => {
            $("body").removeClass("popup_no_scroll");
            if(resp === false) {
                this.props.msgHandler("Error while allocating Private IP", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;
            }
            if(resp.data != null) {
                if(resp.data.hasOwnProperty("badRequest")) {
                    this.props.msgHandler("Error while allocating Private IP", "error");
                    this.props.bgShadowHandler(false);
                    this.clearToastMessage();
                    return;
                }
                const privateIP = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Private IP has been added to instance " + logInstanceName,
                    "operation": "Private IP added to instance",
                    "region": logRegion
                };
                AuditLog.storeAuditLogs(privateIP, "instance").then((resp) => {
                    if(resp === false);
                });

                let ipv4prijson = {
                    "ipv4addrs": resp.data.interfaceAttachment.fixed_ips[0].ip_address,
                    "gateway": "N/A",
                    "type": "Private"

                };

                this.setState({
                    enableAddIpv4: false,
                    ipv4list: this.state.ipv4list.concat(ipv4prijson),
                    isPrivateIpExists: true
                });
                this.props.msgHandler("Private IP has been added successfully", "success");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
            }

        }).catch(error => {
            this.setState({
                enableAddIpv4: false
            });
            this.props.msgHandler("Error while adding private IP, try after sometime.", "error");
            this.props.bgShadowHandler(false);
            this.clearToastMessage();
        });
    };
    enablePrivateIPv4 = () => {

        /**if(this.props.instImage != ""){
            let image = this.props.instImage.name
            let imageName = image.split("-")
            let name =  imageName[0];
            let version = imageName[1];
            if(name === "Ubuntu" && (version.indexOf(20) > -1 || version.indexOf(18) > -1 || version.indexOf(16) > -1)){
                this.setState({
                    isNoteShown : true
                })
            }
            else{
                this.setState({
                    isNoteShown : false
                })
            }
        }*/

        this.setState({
            enableAddIpv4: true,
            isNoteShown: false
        });
        $("body").addClass("popup_no_scroll");
    };

    enablePublicIPv4 = () => {
        if(localStorage.getItem("status") === 'S') return;
        this.setState({
            enableAddPublicIpv4: true
        });

        $("body").addClass("popup_no_scroll");

    };

    getIpLimitAndPrice = () => {
        this.props.bgShadowHandler(true);
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/networks/ipprice/" + this.props.instance.region + "/" + userId, axiosRequestWithAuth).then(resp => {
            resp = resp.data;
            this.setState({
                setIpPrice: resp.amount,
                setIpLimit: resp.ip_allow_count
            });
            this.getInstanceData();
        })
            .catch(error => {
                this.props.bgShadowHandler(false);
            });
    };

    enableDeleteIpv4 = (ip) => {
        this.setState({
            enableDeleteIpv4PopUp: true,
            currentIp: ip
        });
        $("body").addClass("popup_no_scroll");
    };

    deleteIpAdd = (ip) => {
        $("body").removeClass("popup_no_scroll");
        this.props.bgShadowHandler(true);
        this.setState({
            enableDeleteIpv4PopUp: false
        });

        NetworkService.deleteIP(this.props.instance.id, this.props.instance.region, ip, this.props.instance.name).then(resp => {
            if(resp == false) {
                this.props.bgShadowHandler(false);
            }
            this.setState({
                publicIpStatus: "delete",
                indexIp: 0
            });
            setTimeout(() => { this.getServerDetails(); }, 5000);

        }).catch(error => {
            this.props.bgShadowHandler(false);
        });
    };

    addPublicIpv4 = () => {
        this.props.bgShadowHandler(true);

        NetworkService.addPublicIp(this.props.instance.id, this.props.instance.region, this.props.instance.name).then(resp => {
            this.setState({
                enableAddPublicIpv4: false
            });
            $("body").removeClass("popup_no_scroll");
            if(resp == false) {
                this.props.msgHandler("Error while adding IPV4", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;
            }
            if(resp.data == "IP_EXISTS_ERROR") {
                this.props.msgHandler("IP address cannot be allocated at the moment. Try again later.", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;

            }
            if(resp.data == "ERROR") {
                this.props.msgHandler("Error while adding IPV4", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;
            }
            if(resp.data == "NO_PORT_FOUND") {
                this.props.msgHandler("Error while adding IPV4", "error");
                this.props.bgShadowHandler(false);
                this.clearToastMessage();
                return;
            }
            this.setState({
                publicIpStatus: "add",
                indexIp: 0
            });
            setTimeout(() => { this.getServerDetails(); }, 5000);

        })
            .catch(error => {
                this.props.bgShadowHandler(false);
            });
    };


    getServerDetails = () => {
        instanceService.getServerDetailsById(this.props.computeRegionUrl, this.props.instance.id).then(resp => {
            this.setState({
                addresses: resp.addresses
            }, this.getAdditionalIpDetails());

        })
            .catch(er => {
                this.props.bgShadowHandler(false);
            });
    };

    rDNSSlider = (event, currIdx, ip4Or6) => {
        if(ip4Or6 === 4) {
            $(".reverseDnsSlider").addClass("active");
            setTimeout(() => {
                document.getElementById("rdnsText").focus();
            }, 400);
            this.setState({
                rdnsErrMsg: " ",
                rDnsIpv4SliderCurrIdx: currIdx,
                rDnsIpv4CurrVal: this.state.rDnsIpv4List[currIdx].rdns,
                currSliderIp: 4
            });
        }
        if(ip4Or6 === 6) {
            $(".ipv6_editrdnsDnsSlider").addClass("active");
            this.setState({
                rdnsErrMsg: " ",
                rDnsIpv6SliderCurrIdx: currIdx,
                rDnsIpv6CurrVal: this.state.rDnsIpv6List[currIdx].rdns,
                currSliderIp: 6
            });
        }

        // ip4Or6 === 4 ?
        // this.setState({
        //     rdnsErrMsg: " ",
        //     rDnsIpv4SliderCurrIdx : currIdx,
        //     rDnsIpv4CurrVal : this.state.rDnsIpv4List[currIdx].rdns ,
        //     currSliderIp : 4
        // }) :
        // this.setState({
        //     rdnsErrMsg: " ",
        //     rDnsIpv6SliderCurrIdx : currIdx,
        //     rDnsIpv6CurrVal : this.state.rDnsIpv6List[currIdx].rdns ,
        //     currSliderIp : 6
        // })      
    };

    addRDNSDetails = (event) => {
        this.state.currSliderIp === 4 ?
            this.setState({
                rDnsIpv4CurrVal: event.target.value
            }) :
            this.setState({
                rDnsIpv6CurrVal: event.target.value
            });
    };

    OnSubmitRdnsRequest = (event) => {
        this.setState({ rdnsSubmitLoader: true });
        if((this.state.rDnsIpv4SliderCurrIdx !== -1) && (this.state.currSliderIp === 4)) {
            console.log(this.state.rDnsIpv4List);
            let rdnsVal = this.state.rDnsIpv4CurrVal;
            let ip = this.state.rDnsIpv4List[this.state.rDnsIpv4SliderCurrIdx].ip;
            let inputmapExists;
            if(rdnsVal && rdnsVal === this.state.rDnsIpv4List[this.state.rDnsIpv4SliderCurrIdx].rdns) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "There is no change in the existing Reverse DNS forward entry. Enter a Reverse DNS forward entry that already exists in the record" });
            }
            else if(!rdnsVal) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "Enter a domain to perform the Reverse DNS lookup" });
            }
            else if(!isValidDomain(rdnsVal, { subdomain: true })) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "Enter a valid domain" });
            }
            else {
                this.IsRdnsInputMappedApiCall(ip, rdnsVal).then((resp) => {
                    inputmapExists = resp;
                    if(isValidDomain(rdnsVal, { subdomain: true }) && inputmapExists) {
                        $(".reverseDnsSlider").removeClass("active");
                        let currIdx = this.state.rDnsIpv4SliderCurrIdx;
                        let tempList = [...this.state.rDnsIpv4List];
                        let tempObj = { ...tempList[currIdx] };
                        //tempObj.rdns = rdnsVal ;
                        let ipAdd = tempObj.ip;
                        let ipType = tempObj.type;
                        // console.log(currIdx)
                        // console.log(this.state.rDnsIpv4List)
                        if(this.state.rDnsIpv4List[currIdx].id !== -1) {
                            //console.log("called update")
                            let id = tempObj.id;
                            let status = tempObj.status;
                            this.upateInstanceRdnsData(id, status, rdnsVal);
                            this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "" });
                        }
                        if(this.state.rDnsIpv4List[currIdx].id === -1) {
                            //console.log("called create")
                            this.createInstanceRdnsData(rdnsVal, ipAdd, ipType).then((resp) => {
                                //console.log(resp)
                                tempObj.id = resp.id;
                                tempList[currIdx] = tempObj;
                                this.setState({ rDnsIpv4List: tempList, rdnsSubmitLoader: false, rdnsErrMsg: "" });
                            });
                        }
                    }
                    else if(!inputmapExists) {
                        this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "No DNS A record found for \"" + rdnsVal + "\" pointing to \"" + ip + "\". Please create a DNS A record for \"" + rdnsVal + "\" before requesting a Reverse DNS record. If you have updated your domain service recently, the changes may take some time to reflect." });
                    }
                });
            }
        }
        if((this.state.rDnsIpv6SliderCurrIdx !== -1) && (this.state.currSliderIp === 6)) {
            let rdnsVal = this.state.rDnsIpv6CurrVal;
            let ip = this.state.rDnsIpv6List[this.state.rDnsIpv6SliderCurrIdx].ip;
            let inputmapExists;
            if(rdnsVal && rdnsVal === this.state.rDnsIpv6List[this.state.rDnsIpv6SliderCurrIdx].rdns) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "There is no change in the existing Reverse DNS forward entry. Enter a Reverse DNS forward entry that already exists in the record" });
            }
            else if(!rdnsVal) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "Enter a domain to perform the Reverse DNS lookup" });
            }
            else if(!isValidDomain(rdnsVal, { subdomain: true })) {
                this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "Enter a valid domain" });
            }
            else {
                this.IsRdnsInputMappedApiCall(ip, rdnsVal).then((resp) => {
                    inputmapExists = resp;
                    if(isValidDomain(rdnsVal, { subdomain: true }) && inputmapExists) {
                        $(".reverseDnsSlider").removeClass("active");
                        let currIdx = this.state.rDnsIpv6SliderCurrIdx;
                        let tempList = [...this.state.rDnsIpv6List];
                        let tempObj = { ...tempList[currIdx] };
                        tempObj.rdns = rdnsVal;
                        let ipAdd = tempObj.ip;
                        let ipType = tempObj.type;
                        if(this.state.rDnsIpv6List[currIdx].id !== -1) {
                            let id = tempObj.id;
                            let status = tempObj.status;
                            this.upateInstanceRdnsData(id, status, rdnsVal);
                        }
                        if(this.state.rDnsIpv6List[currIdx].id === -1) {
                            this.createInstanceRdnsData(rdnsVal, ipAdd, ipType).then((resp) => {
                                tempObj.id = resp.id;
                            });
                        }
                        tempList[currIdx] = tempObj;
                        //this.setState({rDnsIpv6List: tempList, rdnsSubmitLoader: false, rdnsErrMsg: ""}) ;
                        this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "" });
                    }
                    else if(!inputmapExists) {
                        this.setState({ rdnsSubmitLoader: false, rdnsErrMsg: "No DNS AAAA record found for \"" + rdnsVal + "\" pointing to \"" + ip + "\". Please create a DNS AAAA record for \"" + rdnsVal + "\" before requesting a Reverse DNS record. If you have updated your domain service recently, the changes may take some time to reflect." });
                    }
                });
            }
        }
    };

    rdnsSliderOnCancel() {
        $(".reverseDnsSlider").removeClass("active");
    }

    rdnsSliderOnClose() {
        if(this.state.currSliderIp === 4) {
            $(".reverseDnsSlider").removeClass("active");
        }
        if(this.state.currSliderIp === 6) {
            $(".ipv6_editrdnsDnsSlider").removeClass("active");
        }
    }

    getInstanceRdnsData() {
        axiosInstance.get("/rdns/" + this.props.instanceId + "/all", axiosRequestWithAuth).then(resp => {
            let data = resp.data;
            //console.log(data)
            let newDataipv4 = [];
            let newDataipv6 = [];
            this.state.ipv4list.forEach((ele) => {
                //console.log(ele)              
                let ipMatchFound = false;
                let matchedRdnsDefault = '';
                this.IsIpMappedApiCall(ele.ipv4addrs).then(resp => {
                    matchedRdnsDefault = resp;
                    //debugger
                    for(var i = 0; i < data.length; i++) {
                        //debugger
                        if(data[i].ipAddress == ele.ipv4addrs) {
                            ipMatchFound = true;
                            if(data[i].status !== 1) {
                                data[i].rdns = matchedRdnsDefault;
                            }
                            newDataipv4[ele.order] = { id: data[i].id, ip: ele.ipv4addrs, type: ele.type, rdns: data[i].rdns, status: data[i].status };
                            i = data.length;
                        }
                    }
                    if(!ipMatchFound) {
                        let currRdns = '';
                        if(ele.type === "Public") {
                            currRdns = matchedRdnsDefault;
                        }
                        newDataipv4[ele.order] = { id: -1, ip: ele.ipv4addrs, type: ele.type, rdns: currRdns, status: 0 };
                    }
                });


            });
            this.state.ipv6list.forEach((ele, indx) => {
                let ipMatchFound = false;
                let matchedRdnsDefault = '';
                this.IsIpMappedApiCall(ele.ipv6addrs).then(resp => {
                    matchedRdnsDefault = resp;
                    for(var i = 0; i < data.length; i++) {
                        if(data[i].ipAddress === ele.ipv6addrs) {
                            ipMatchFound = true;
                            if(data[i].status !== 1) {
                                data[i].rdns = matchedRdnsDefault;
                            }
                            newDataipv6.push({ id: data[i].id, ip: ele.ipv6addrs, type: ele.type, rdns: data[i].rdns, status: data[i].status });
                            i = data.length;
                        }
                    }
                    if(!ipMatchFound) {
                        let currRdns = '';
                        if(ele.type === "Public") {
                            currRdns = matchedRdnsDefault;
                        }
                        newDataipv6.push({ id: -1, ip: ele.ipv6addrs, type: ele.type, rdns: currRdns, status: 0 });
                    }
                });


            });
            this.setState({
                rDnsIpv4List: newDataipv4,
                rDnsIpv4ListLoaded: true,
                rDnsIpv6List: newDataipv6,
                rDnsIpv6ListLoaded: true,
            });
            // console.log(newDataipv4)
            // console.log(this.state.rDnsIpv4List)
        }).catch(err => {
            console.log(err);
        });

    }


    async createInstanceRdnsData(rdnsVal, addr, type) {
        try {
            let resp = await axiosInstance.post('/rdns/' + localStorage.getItem('userId'),
                {
                    instanceId: this.props.instanceId,
                    ipAddress: addr,
                    ipAddressType: type,
                    rdns: rdnsVal,
                    instanceName: this.props.instance.name
                }, axiosRequestWithAuth);
            //console.log(resp)
            if(resp.status === 200) {
                this.props.msgHandler("Your request to update PTR record for the instance has been submitted. Our team is looking into it and you will be informed via email.");
                this.clearToastMessage();
            }
            else {
                this.props.msgHandler("Error while sending request.Please try after sometime", "error");
                this.clearToastMessage();
            }
            return resp.data;
        }
        catch(error) {
            console.log(error);
            this.props.msgHandler("Error while sending request.Please try after sometime", "error");
            this.clearToastMessage();
        }
    }

    async IsIpMappedApiCall(ipAddr) {
        try {
            let resp = await axiosInstance.post('/rdns/domainCheck', { ip: ipAddr }, axiosRequestWithAuth);
            return resp.data;
        }
        catch(error) {
            console.log(error);
        }
    }

    IsRdnsInputMappedApiCall = async (ipAddr, rdnsVal) => {
        try {
            let resp = await axiosInstance.post('/rdns/' + 'rdnsLookup', { ip: ipAddr, rdns: rdnsVal }, axiosRequestWithAuth);
            return resp.data;
        }
        catch(error) {
            console.log(error);
        }
    };

    upateInstanceRdnsData(id, status, updatedRdns) {
        axiosInstance.post("/rdns/" + status + "/" + id + "/" + this.state.userId,
            {
                rdns: updatedRdns,
                userId: localStorage.getItem('userId'),
                instanceName: this.props.instance.name
            }
            , axiosRequestWithAuth)
            .then(resp => {
                if(resp.status === 200) {
                    this.props.msgHandler("Your request to update PTR record for the instance has been submitted. Our team is looking into it and you will be informed via email.");
                    this.clearToastMessage();
                }
                else {
                    this.props.msgHandler("Error while sending request.Please try after sometime", "error");
                    this.clearToastMessage();
                }

            }).catch(err => {
                console.log(err);
                this.props.msgHandler("Error while sending request.Please try after sometime", "error");
                this.clearToastMessage();
            });
    }

    render() {
        var username = 'root';
        var isIpHide = false;
        if(this.props.instance.metadata?.instType === 'rancher') {
            username = 'rancher';
            isIpHide = true;
        }

        return (
            <div>

                <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper network_setting_module" }>

                    { this.state.isdatapresent ?
                        <div>
                            <div className="outer_empty_wrap">
                                <div className="inner_empty_wrap">
                                    <div className="svg_wrap empty_icon network_empty"></div>
                                    <p className="empty_title">No Networking</p>
                                </div>
                            </div>
                        </div>

                        :
                        <div>
                            <div className="settModule_head_wrap">
                                <div className="settModule_head_lhs">
                                    <h2>Networking</h2>
                                    <p className="head_info" >View the SSH access info and IP addresses for the instance</p>
                                </div>
                            </div>
                            <div className="networkModule_wrap">
                                <div className="ntwking_ip_wrap">
                                    <ul className="ip_wrap">
                                        <li>
                                            <div className="ip_head">SSH Access</div>
                                            <div className="ip_info">ssh { username }@{ this.state.resultIP } <span data-tip data-for="sshaccess" className="copy_icon svg_wrap" onMouseLeave={ () => this.setState({ issshaccess: true }) } onClick={ (e) => this.copyToclipboard(e, 'ssh ' + username + '@' + this.state.resultIP, "sshaccess") }><svg x="0px" y="0px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                            </svg></span><ReactTooltip id="sshaccess" effect='solid' place="top" >{ this.state.issshaccess ? "copy" : "copied" }</ReactTooltip>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="ip_head">IPv4 Address</div>
                                            <div className="ip_info">{ this.state.resultIP } <span data-tip data-for="ipv4adrs" className="copy_icon svg_wrap" onMouseLeave={ () => this.setState({ iscopyipv4: true }) } onClick={ (e) => this.copyToclipboard(e, this.state.resultIP, "ipv4") }><svg x="0px" y="0px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                            </svg></span><ReactTooltip id="ipv4adrs" effect='solid' place="top" >{ this.state.iscopyipv4 ? "copy" : "copied" }</ReactTooltip>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="ip_head">IPv6 Address</div>
                                            { this.state.ipv6 !== null && this.state.ipv6 !== undefined && this.state.ipv6 !== "" ?
                                                <div className="ip_info">{ this.state.ipv6 }

                                                    <span data-tip data-for="ipv6adrs" className="copy_icon svg_wrap" onMouseLeave={ () => this.setState({ iscopyipv6: true }) } onClick={ (e) => this.copyToclipboard(e, this.state.ipv6, "ipv6") }><svg x="0px" y="0px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                                    </svg></span>
                                                    <ReactTooltip id="ipv6adrs" effect='solid' place="top" >{ this.state.iscopyipv6 ? "copy" : "copied" }</ReactTooltip>
                                                </div>
                                                : "N/A" }



                                        </li>
                                    </ul>
                                </div>
                                <div className="ip_addr_desc">
                                    <h2>IP Addresses</h2>

                                    <p className="title_txt">The public and private IPv4 address for the instance. <a href="https://www.idrivecompute.com/ipv4-address.htm" target="_blank" style={ { display: !isIpHide ? '' : 'none' } }>Know more about <b>adding and removing additional IPv4 addresses</b></a></p>

                                    <div className="ip_table_wrap clearfix">
                                        <div className="ip_head_wrap">
                                            <h3>IPv4</h3>
                                            <div className="cta_wrap clearfix">
                                                { this.state.isPrivateIpExists || this.getFlavorDetails(this.state.flavour.id) ? "" :
                                                    <div className="btn_wrap">
                                                        <input type="button" name="" value="Add Private IPv4" className={ this.props.isTaskStateNull ? "common_cta_btn ip_btn ip_btn_private" : "common_cta_btn ip_btn ip_btn_private disabled" } onClick={ () => this.enablePrivateIPv4() } disabled={ !this.props.isTaskStateNull }></input>
                                                    </div>
                                                }
                                                <div className="btn_wrap"><span className="icon"></span>
                                                    <input type="button" style={ { display: !isIpHide && this.state.additionalIPCount < this.state.setIpLimit ? "" : "none" } } name="" value="Add Public IPv4" className={ this.props.isTaskStateNull && localStorage.getItem("status") !== 'S' ? "common_cta_btn ip_btn ip_btn_public" : "common_cta_btn ip_btn ip_btn_public disabled" } onClick={ () => this.enablePublicIPv4() } disabled={ (!this.props.isTaskStateNull || localStorage.getItem("status") === 'S') } />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tabular_data_wrap reverseDns ipv4Table">
                                            <div className="table_header">
                                                <ul>
                                                    <li className="th">
                                                        <div className="col col1">Address</div>
                                                        <div className="col col2" >Default Gateway</div>
                                                        <div className="col col3">Type</div>
                                                        <div className="col col4">Reverse DNS
                                                            <div className="reverseDns-tooltip">
                                                                <span className="question_icon reverseDns-info-icon">
                                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="15px">?</text>
                                                                    </svg>
                                                                </span>
                                                                <div className="reverseDns-info-tooltip">
                                                                    <p><a href="https://www.idrivecompute.com/faq_instances.htm#ptr" target="_blank">Configure instance for reverse DNS. <span>{ "Know more >" }</span></a></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="table_data">
                                                <ul>
                                                    {
                                                        this.state.ipv4list.map((data, index) => (

                                                            <li className={ data.type != "Private" && this.checkAdditionalIp(data.ipv4addrs) && this.state.additionalIPCount > 0 ? "tr publicIp" : "tr rowOptions" } key={ index }>
                                                                <div className="col col1"><span>{ data.ipv4addrs }</span>

                                                                    { data.type != "Private" && !this.checkAdditionalIp(data.ipv4addrs) && this.state.additionalIPCount > 0 ?
                                                                        <span className="mainIp">Main IP</span>
                                                                        :
                                                                        ""
                                                                    }
                                                                    <span className='copy_icon_blk'>
                                                                        <span className="copy_icon svg_wrap" data-tip data-for={ data.ipv4addrs } onMouseLeave={ () => this.setState({ isCopyIPAdd: true }) } onClick={ (e) => this.copyToclipboard(e, data.ipv4addrs, "ipv4add") } currentitem="false">
                                                                            <svg x="0px" y="0px" width="14px" height="16.5px" viewBox="0 0 14 16.5" enableBackground="new 0 0 14 16.5" xmlSpace="preserve">
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#3B9FD8" d="M3.1,14.8v-11h10v11H3.1z M12.1,4.8h-8v9h8V4.8z M11.1,7.8h-6v-1h6  V7.8z M11.1,9.8h-6v-1h6V9.8z M9.1,11.8h-4v-1h4V11.8z M2.1,11.8h-1v-9v-1h1h8v1h-8V11.8z"></path>
                                                                            </svg>

                                                                        </span>
                                                                        <ReactTooltip id={ data.ipv4addrs } place="right" effect="solid">{ this.state.isCopyIPAdd ? "copy" : "copied" }</ReactTooltip>
                                                                    </span>
                                                                </div>
                                                                <div className="col col2" ><span>{ data.gateway }</span></div>
                                                                <div className="col col3"><span>{ data.type }</span></div>
                                                                <div className="col col4"><span className={ (data.type === "Public" && typeof (this.state.rDnsIpv4List[index]) === 'undefined') ? "SubmitLoader" : "" } title={ typeof (this.state.rDnsIpv4List[index]) !== 'undefined' ? this.state.rDnsIpv4List[index].rdns : "" }>{ (this.state.rDnsIpv4List.length === 0) || (typeof (this.state.rDnsIpv4List[index]) === 'undefined') ? " " : this.state.rDnsIpv4List[index].rdns }</span></div>
                                                                <div className="row_options">
                                                                    <ReactTooltip id="rdnsTooltip" place="top" effect="solid">Edit RDNS</ReactTooltip>
                                                                    <a style={ { display: data.type === "Public" && typeof (this.state.rDnsIpv4List[index]) !== 'undefined' ? "block" : "none" } } href="#" onClick={ (e) => { this.rDNSSlider(e, index, 4); e.preventDefault(); } } className="editDns" data-tip data-for="rdnsTooltip">
                                                                        <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#0089e5" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                                    </a>

                                                                    { data.type != "Private" && this.checkAdditionalIp(data.ipv4addrs) && this.state.additionalIPCount > 0 ?
                                                                        <React.Fragment>
                                                                            <a href="javascript:;" className="delete_Ipv4" data-tip data-for="deleteip" onClick={ () => this.enableDeleteIpv4(data.ipv4addrs) }>
                                                                                <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#e06b70" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                                </svg>
                                                                            </a>
                                                                            <ReactTooltip id="deleteip" place="top" effect="solid">Remove</ReactTooltip>
                                                                        </React.Fragment> : "" }
                                                                </div></li>

                                                        ))
                                                    }


                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ip_table_wrap clearfix">
                                        <div className="ip_head_wrap">
                                            <h3>IPv6</h3>
                                        </div>
                                        <div className="tabular_data_wrap reverseDns ipv6Table">
                                            <div className="table_header">
                                                <ul>
                                                    <li className="th">
                                                        <div className="col col1">Address</div>
                                                        <div className="col col2" >Default Gateway</div>
                                                        <div className="col col3">Type</div>
                                                        <div className="col col4">Reverse DNS
                                                            <div className="reverseDns-tooltip">
                                                                <span className="question_icon reverseDns-info-icon">
                                                                    <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                        <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="15px">?</text>
                                                                    </svg>
                                                                </span>
                                                                <div className="reverseDns-info-tooltip">
                                                                    <p><a href="https://www.idrivecompute.com/faq_instances.htm#ptr" target="_blank">Configure instance for reverse DNS. <span>{ "Know more >" }</span></a></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="table_data">
                                                <ul>
                                                    {
                                                        this.state.ipv6list.map((data, index) => (

                                                            <li className="tr rowOptions" key={ index }>
                                                                <div className="col col1">
                                                                    <ReactTooltip id="ipv6Tooltip" place="top" effect="solid" >{ data.ipv6addrs }</ReactTooltip>
                                                                    <span data-tip data-for="ipv6Tooltip">{ data.ipv6addrs }</span>
                                                                </div>
                                                                <div className="col col2"><span>{ data.gateway }</span></div>
                                                                <div className="col col3"><span>{ data.type }</span></div>
                                                                <div className="col col4"><span className={ (data.type === "Public" && typeof (this.state.rDnsIpv6List[index]) === 'undefined') ? "SubmitLoader" : "" } title={ typeof (this.state.rDnsIpv6List[index]) !== 'undefined' ? this.state.rDnsIpv6List[index].rdns : "" }>{ this.state.rDnsIpv6List.length === 0 || (typeof (this.state.rDnsIpv6List[index]) === 'undefined') ? " " : this.state.rDnsIpv6List[index].rdns }</span></div>
                                                                <div className="row_options">
                                                                    <ReactTooltip id="rdnsTooltip" place="top" effect="solid" > Edit RDNS</ReactTooltip>
                                                                    <a style={ { display: data.type === "Public" && typeof (this.state.rDnsIpv6List[index]) !== 'undefined' ? "block" : "none" } } href="#" onClick={ (e) => { this.rDNSSlider(e, index, 6); e.preventDefault(); } } className="editDns edit_ipv6" data-tip data-for="rdnsTooltip">
                                                                        <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#0089e5" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                                    </a>
                                                                </div>
                                                            </li>

                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="firewall_sec" style={ { display: this.getFlavorDetails(this.state.flavour.id) ? "none" : "" } }>
                                    <h2>Firewalls</h2>
                                    <div className="firewall_sett_wrap">
                                        <div className="firewall_head_wrap">
                                            <p>Manage firewalls for your instances</p>
                                            {/*<div className="btn_wrap"><span className="icon"></span>
                                    <input type="button" name="" value="Add Firewall" className="common_cta_btn add_firewall_cta" onClick={() => this.props.history.push('/firewall')}></input>
                                </div>*/}
                                        </div>
                                        <div className="added_firewall clearfix" onClick={ this.getFocus }>
                                            <ul className="tags_container">
                                                {
                                                    this.state.firewalls.map((fire, i) =>
                                                        <li key={ i }><div className="firewall_tag"> <span className="firewall_icon"><span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 25 25" enableBackground="new 0 0 25 25" xmlSpace="preserve">
                                                            <g>
                                                                <path fill="#5AA6D8" d="M23.7,12.9c-0.1,0.7-0.4,2.7-1.9,2.8c1.2-4.3-2.9-7.5-3.9-7.6c0.5,2.6-0.6,3.2-2.4,5.7   c-3.8,5.7,1.5,9.3,1.5,9.3c0.5,0.4,1.3,0.2,3.4,0.3C27.4,21.4,23.8,12.1,23.7,12.9z" />
                                                                <path fill="#5AA6D8" d="M12.6,21.4h-0.3v-4.7h0.3v-1.9h-5V10c0-0.6-0.4-0.9-0.9-0.9S5.8,9.5,5.8,10v4.7H1.9V10h4.7h7.6   c0-0.6,0-1.3,0-1.9h-1.9V3.4H19c1,0,1.9,0.9,1.9,1.9v1.9v0.9c0,0.6,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9V7.2V4.4c0-1.6-1.2-2.8-2.8-2.8   H2.8C1.2,1.6,0,2.9,0,4.4v16.1c0,1.6,1.2,2.8,2.8,2.8h8.5h1.2v-2H12.6z M1.9,5.3c0-1,0.9-1.9,1.9-1.9h6.6v4.7H1.9V5.3z M10.4,21.4   H3.8c-1,0-1.9-0.9-1.9-1.9v-2.8h8.5V21.4z" />
                                                            </g>
                                                        </svg></span> </span> { fire.name } <span className="close_icon" onClick={ () => this.removeSelectedFirewall([fire.name]) }></span> </div></li>
                                                    )
                                                }
                                                <span className="inp_box"><input type="text" autoComplete="off" placeholder={ this.state.firewalls.length <= 0 ? "Attach or detach firewall" : "" } name="inputFirewallSearch" className="input_search" value={ this.state.inputFirewallSearch } onClick={ (e) => this.getFirewallDrop(e) } onChange={ (e) => this.firewallSearch(e) }></input></span>
                                            </ul>
                                            <div className="dropdown_component addedFirewall_dropdown" >
                                                { this.state.firewallDropDown.length > 0 ?
                                                    <ul>
                                                        { this.state.firewallDropDown.map((filteredFirewall, i) =>
                                                            <li key={ i }><span style={ { width: '100%' } } onClick={ () => this.addSelectedFirewall([filteredFirewall.name]) }>{ filteredFirewall.name }</span></li>
                                                        )
                                                        }
                                                    </ul>
                                                    :
                                                    <ul>
                                                        <li><span>No firewall found in this region to apply</span></li>
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="network_traffic_table clearfix ipvRules">
                                        <h2>IPv4 Rules</h2>
                                        <NetworkRules rulesListApi={ this.state.ipv4Rules } type="IPv4"
                                            bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) }
                                            msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } />
                                    </div>
                                    <div className="network_traffic_table clearfix ipvRules">
                                        <h2>IPv6 Rules</h2>
                                        <NetworkRules rulesListApi={ this.state.ipv6Rules } type="IPv6"
                                            bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) }
                                            msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } />
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                </section>
                <div className="main_slider reverseDnsSlider">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ (e) => this.rdnsSliderOnClose() } ></div>
                            <div className="ntwk_rhs_slide_wrap">
                                <div className="head_block">
                                    <h2>Edit Reverse DNS</h2>
                                </div>
                                <div className="ntwkRhs_content_wrap">
                                    <div className="common_txtBox_row">
                                        <label>Enter a pointer record to perform Reverse DNS lookup</label>
                                        <input type="text" id="rdnsText" autoComplete="off" className="txt_box" value={ this.state.currSliderIp === 4 ? this.state.rDnsIpv4CurrVal : (this.state.currSliderIp === 6 ? this.state.rDnsIpv6CurrVal : "") } onChange={ this.addRDNSDetails } />
                                        <span className="err_msg" style={ { display: this.state.rdnsErrMsg ? "block" : "none", color: "red" } }>{ this.state.rdnsErrMsg }</span>
                                    </div>
                                    <p class="info_txt"><strong>Note:</strong> A pointer record must exist for the requested domain to perform RDNS lookup</p>
                                    <div className="cta_wrap">
                                        <input type="button" name="" value="Request" onClick={ (e) => this.OnSubmitRdnsRequest(e) } className={ this.state.rdnsSubmitLoader ? "common_cta_btn blue SubmitLoader" : "common_cta_btn blue" } />
                                        {/* rdnsSubmitLoader */ }
                                        <input type="button" name="" value="Cancel" onClick={ this.rdnsSliderOnCancel } className="common_cta_btn transparentGrey" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main_slider ipv6_editrdnsDnsSlider">
                    <div class="slider_bg_shadow"></div>
                    <div class="slider_wrapper">
                        <div class="main_slider_container">
                            <div class="close_icon" onClick={ (e) => this.rdnsSliderOnClose() }></div>
                            <div class="ntwk_rhs_slide_wrap">
                                <div class="head_block">
                                    <h2>Edit Reverse DNS</h2>
                                </div>
                                <div class="ntwkRhs_content_wrap">
                                    <p class="info_txt"><a href="https://www.idrivecompute.com/support.htm" target="_blank">Contact support </a>to raise a ticket to edit Reverse DNS for the requested domain.</p>
                                    <p class="info_txt"><strong>Note: </strong>An 'AAAA' record must exist for the domain</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={ this.state.enableAddIpv4 ? "main_slider ntwk_rhs_slider add_private_ipv4 active" : "main_slider ntwk_rhs_slider add_private_ipv4" }>
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => { this.setState({ enableAddIpv4: false }); $("body").removeClass("popup_no_scroll"); } }></div>
                            <div className="ntwk_rhs_slide_wrap">
                                <div className="head_block">
                                    <h2>Allocate Private IPv4</h2>
                                </div>
                                <div className="ntwkRhs_content_wrap">

                                    <p className="info_txt">Assign a private IPv4 address to the instance to enable private communication with other instances within your account</p>
                                    <p className="note_txt"><b>Note:</b> The instance will be rebooted to complete this operation. <a href="https://www.idrivecompute.com/faq_instances.htm#private-ipaddress" target="_blank">Know more.</a></p>
                                    <p className="info_txt"></p>
                                    <div className="cta_wrap">
                                        <input type="button" name="" value="Allocate" className="common_cta_btn blue" onClick={ this.allocateIpv4 } />
                                        <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => { this.setState({ enableAddIpv4: false }); $("body").removeClass("popup_no_scroll"); } } />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class={ this.state.enableDeleteIpv4PopUp ? "main_popup delete_ipv4_popup active" : "main_popup delete_ipv4_popup" }>
                    <div class="main_popup_wrapper">
                        <div class="main_popup_bg_shadow"></div>
                        <div class="main_popup__inner">
                            <div class="popup_wrap"> <span class="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ () => { this.setState({ enableDeleteIpv4PopUp: false }); $("body").removeClass("popup_no_scroll"); } }></span>
                                <div class="popup_header">
                                    <div class="sub_title">Remove Public IPv4 Address { this.state.currentIp }</div>
                                </div>
                                <div class="popup_body">
                                    <p>Removing this public IPv4 address is irreversible. You must remove this IPv4 address manually from the instance. Are you sure you want to proceed?</p>
                                    <p class="info_txt"><a target="_blank" href="https://www.idrivecompute.com/ipv4-address.htm#remove-ipv4">Know more about <b>removing IPv4 addresses</b></a></p>
                                </div>
                                <div class="popup_footer">
                                    <div class="popup_footer__btns">
                                        <div class="btn btn_confirm" onClick={ () => this.deleteIpAdd(this.state.currentIp) }>Remove</div>
                                        <div class="btn btn_cancel" onClick={ () => { this.setState({ enableDeleteIpv4PopUp: false }); $("body").removeClass("popup_no_scroll"); } }>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={ this.state.enableAddPublicIpv4 ? "main_slider ntwk_rhs_slider add_public_ipv4 active" : "main_slider ntwk_rhs_slider add_public_ipv4" }>
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => { this.setState({ enableAddPublicIpv4: false }); $("body").removeClass("popup_no_scroll"); } }></div>
                            <div className="ntwk_rhs_slide_wrap">
                                <div className="head_block">
                                    <h2>Allocate Public IPv4</h2>
                                </div>
                                <div className="ntwkRhs_content_wrap">
                                    <p>Add a public IPv4 address</p>
                                    <ul>
                                        <li>Each additional IPv4 address costs <strong>${ this.state.setIpPrice }/month</strong></li>
                                        <li>You must configure additional IPs manually for your instances</li>
                                        <li>You can add a maximum of { this.state.setIpLimit } additional IPs per instance</li>
                                    </ul>
                                    <div className="cta_wrap">
                                        <input type="button" name="" value="Allocate" className="common_cta_btn blue" onClick={ () => this.addPublicIpv4() } />
                                        <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => { this.setState({ enableAddPublicIpv4: false }); $("body").removeClass("popup_no_scroll"); } } />
                                    </div>
                                    <p className="info_txt" style={ { display: "none" } }><strong>Note:</strong> The instance must be restarted to add the IP address and you must manually configure it for the instance.</p>
                                    <p class="info_txt"><a target="_blank" href="https://www.idrivecompute.com/ipv4-address.htm">Know more about <b>adding IPv4 addresses</b></a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Networking);
